import {
  Box,
  Button,
  Flex,
  Heading,
  Text,
  useColorMode,
} from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useSearchParamsHandler from "../../hooks/useSearchParamsHandler";
import SearchInput from "../SearchInput/SearchInput";
import Cookies from "js-cookie";
import { getCurrentColor } from "../../constants";
import { InfoOutlineIcon } from "@chakra-ui/icons";

const ShipTo = ({ setShowLocation, showLocation }) => {
  const cookieZip = Cookies.get("user-zip");
  const [zipCode, setZipCode] = useState(cookieZip ? cookieZip : "");
  const [searchParams, setSearchParams] = useSearchParams();
  const { params, addOrUpdateParam, deleteParam } = useSearchParamsHandler();
  const [zipCodeError, setZipCodeError] = useState(false);
  const [showZipPopup, setShowZipPopup] = useState(false);
  const popupRef = useRef(null);
  const { colorMode } = useColorMode();
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("isClosedTooltip")) {
      setTimeout(() => setShowZipPopup(true), 2500);
    }

    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowZipPopup(false);
        localStorage.setItem("isClosedTooltip", true);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const getZipCode = (zipCode) => {
    setZipCodeError(false);
    if (zipCode.length === 0) {
      setZipCodeError(true);
      return;
    }

    if (!cookieZip && zipCode) {
      Cookies.set("user-zip", zipCode.toString(), { expires: 30 });
      Cookies.set("user-consent", 0, { expires: 30 });
      // addOrUpdateParam("user-zip", zipCode);
    } else if (
      cookieZip !== zipCode &&
      searchParams.get("user-zip") !== zipCode
    ) {
      // setSearchParams({ ...params, "user-zip": zipCode || cookieZip });
      Cookies.remove("user-zip");
      Cookies.set("user-zip", zipCode.toString(), { expires: 30 });
    } else if (searchParams.get("user-zip") && !cookieZip) {
      // deleteParam("zip", searchParams.get("user-zip"));
    } else if (cookieZip && !searchParams.get("user-zip")) {
      // addOrUpdateParam("user-zip", cookieZip);
    }
  };

  const clearCookies = () => {
    Cookies.remove("user-zip");
    Cookies.remove("user-consent");
    Cookies.remove("user-write-zip");
    setZipCode("");
    deleteParam("user-zip", searchParams.get("user-zip"));
  };

  return (
    <>
      <Flex
        flexDirection={"column"}
        w={"100%"}
        mb={4}
        display={{ base: "block", lg: "flex" }}
        position={"relative"}
      >
        {showZipPopup && (
          <Box
            ref={popupRef}
            position={"absolute"}
            fontSize={"xs"}
            top={{ base: 0, md: -90 }}
            border={"1px solid"}
            borderColor={getCurrentColor(colorMode, "grayC.800", "grayC.2400")}
            left={0}
            p={2}
            zIndex={99}
            borderRadius={"8px"}
            shadow={"xl"}
            color={getCurrentColor(colorMode, "grayC.200", "grayC.2600")}
            bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1700")}
          >
            Accurate shipping costs start with your ZIP code — enter it to see
            exact rates.
          </Box>
        )}
        <Heading as="h3" fontSize={"lg"} w={"100%"} mb={3}>
          Add zip code{" "}
          <InfoOutlineIcon
            cursor={"pointer"}
            ml={1}
            onMouseEnter={() => setShowZipPopup(true)}
            onMouseLeave={() => setShowZipPopup(false)}
            fontSize={"sm"}
          />
        </Heading>
        <Box position={"relative"} w={"100%"} mb={{ base: 0, lg: 3 }}>
          <Box position={"relative"} zIndex={1}>
            <SearchInput
              w={"100%"}
              icon={false}
              pl={"20px"}
              value={zipCode}
              handleChange={setZipCode}
              border={"1px solid"}
              borderColor={getCurrentColor(
                colorMode,
                "grayC.800",
                "grayC.2400",
              )}
              name="zip"
              placeholder="Zip Code"
            />
            {zipCodeError && (
              <Text
                color={"red.500"}
                position={"absolute"}
                bottom={"-20px"}
                left={"0px"}
                fontSize={"xs"}
                zIndex={3}
              >
                Please enter zip code
              </Text>
            )}
          </Box>
          <Button
            mt={{ base: "40px", lg: 0 }}
            w={{ base: "100%", lg: "auto" }}
            position={{ base: "relative", lg: "absolute" }}
            top={{ base: 0, lg: "50%" }}
            right={"0px"}
            transform={{ base: "translateY(0%)", lg: "translateY(-50%)" }}
            py={"2px"}
            bg={{ base: "blueC.100", lg: "transparent" }}
            _hover={{ bg: { base: "blueC.100", lg: "transparent" } }}
            zIndex={2}
            hidden={+zipCode === +cookieZip}
            onClick={function () {
              +zipCode === +cookieZip ? clearCookies() : getZipCode(zipCode);
              if (setShowLocation) {
                setShowLocation(!showLocation);
              }
              navigate(0);
            }}
          >
            {+zipCode === +cookieZip ? "Clear" : "Save"}
          </Button>
        </Box>
      </Flex>
    </>
  );
};

export default ShipTo;
